import React, {
  createContext,
  useContext,
  useCallback,
  useMemo,
  useState,
} from 'react';

import api from '../services/apiClient';

import IDepartamento from '../interfaces/IDepartament';

interface UserConfigContextData {
  loadDepartamentos: () => void;
  userDepartament: IDepartamento[];
}

const UserConfigContext = createContext<UserConfigContextData>(
  {} as UserConfigContextData
);

function useUserConfig(): UserConfigContextData {
  const context = useContext(UserConfigContext);
  if (!context) {
    throw new Error('useUserConfig must be used within an AuthProvider');
  }
  return context;
}

const UserConfigProvider: React.FC = ({ children }): any => {
  const [userDepartament, setUserDepartament] = useState<IDepartamento[]>(
    [] as IDepartamento[]
  );

  const loadDepartamentos = useCallback((): void => {
    const token = localStorage.getItem('@LiveChat:token');
    const seqUsuario = localStorage.getItem('@LiveChat:seqUsuario');

    api
      .get(`/departamentoUsuario/DepartamentoVinculado/${seqUsuario}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        const result = response.data;

        if (result.success) {
          for (let row = 0; row < result.data.length; row += 1) {
            result.data[row].exibeChatCliente =
              result.data[row].exibeChatCliente === 'S';
            result.data[row].ativo = result.data[row].ativo === 'S';
            result.data[row].corFundoLinha =
              result.data[row].corFundoLinha === 'S';
          }

          setUserDepartament(result.data);
        }
      });
  }, []);

  const valueContext = useMemo(
    () => ({
      loadDepartamentos,
      userDepartament,
    }),
    [loadDepartamentos, userDepartament]
  );

  return (
    <UserConfigContext.Provider value={valueContext}>
      {children}
    </UserConfigContext.Provider>
  );
};

export { useUserConfig, UserConfigProvider };
